import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import BlackboardReaderForm from '../forms/blackboard-reader-form';
import { blackboardReaderValidationSchema } from '../schema/blackboardReader.js';

export default function BlackboardReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Blackboard Reader Node Details',
        altText: 'Blackboard Reader Node',
        defaultLabel: 'Blackboard Reader Node',
      }}
    >
      <CommonNode
        FormComponent={BlackboardReaderForm}
        schemaResolver={blackboardReaderValidationSchema}
      />
    </NodeProvider>
  );
}
